import Vue from 'vue';

const state = {
    matches: {},
    currentBg: '/static/img/pages/main/main_bg.png',
    menuState: false
};

const actions = {
    getMatches({dispatch, commit, getters, rootGetters}, params) {
        let data = params ? params : {offset: 0, limit: 100};
        return new Promise((resolve, reject) => {
            Vue.http.get(rootGetters['apiUrl'] + '/games/?limit='+data.limit+'&offset='+data.offset).then(
                (response) => {
                    commit('updateMatches', response.body);
                    resolve();
                },
                () => {
                    reject();
                }
            )
        });
    },
};

const getters = {
    getMatches: state => state.matches,
    getCurrentBg: state => state.currentBg,
    getMenuState: state => state.menuState,
};

const mutations = {
    updateMatches(state, data) {
        state.matches = data;
    },
    updateCurrentBg(state, str) {
        state.currentBg = str;
    },
    updateMenuState(state, boolean) {
        state.menuState = boolean;
    },
};

export default {
    namespaced: false,
    actions,
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/main.js